module.exports = __webpack_public_path__ + "static/img/IMG_20170905_191113.5b69bd9b.jpg";